import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DateFormatter } from "../../utils/global";
import { getUsersApiCall } from "../../store/actions/projectAction";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import TextField from "../Partial/TextField";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import Button from "../Partial/Button";
import $ from "jquery";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

function UserTable() {
  const users = useSelector((state) => state.project.users);
  const navigate = useNavigate();
  const [value, setValue] = useState(null);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const today = new Date();
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(today.getDate() - 14);

  const dateInputRef = useRef();

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const [filteredUsers, setFilteredUsers] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();

  const fetchApiCall = async (date = null) => {
    let input = {
      search: debouncedQuery,
    };

    if (dateRange?.startDate && dateRange?.endDate) {
      input["startDate"] = dateRange.startDate.toDate();
      input["endDate"] = dateRange.endDate.toDate();
    }
    dispatch(getUsersApiCall(input));
  };

  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  useEffect(() => {
    fetchApiCall();
  }, [dateRange, debouncedQuery]);

  useEffect(() => {
    setFilteredUsers(users);
  }, [users]);

  useEffect(() => {
    if (!dateInputRef.current) return;

    $(dateInputRef.current).daterangepicker(
      {
        autoUpdateInput: false, // Don't auto-fill input
        locale: {
          format: "YYYY-MM-DD",
          cancelLabel: "Clear",
        },
      },
      (start, end) => {
        setDateRange({ startDate: start, endDate: end });
        $(dateInputRef.current).val(
          `${start.format("YYYY-MM-DD")} - ${end.format("YYYY-MM-DD")}`
        );
      }
    );

    // Handle cancel/clear
    $(dateInputRef.current).on("cancel.daterangepicker", function () {
      $(this).val("");
      setDateRange({ startDate: null, endDate: null });
    });

    return () => {
      $(dateInputRef.current).data("daterangepicker")?.remove(); // Cleanup
    };
  }, []);

  return (
    <div className="w-full flex justify-center mt-24">
      <div className="w-[95%] flex flex-col gap-6">
        <div className="flex  items-center gap-5">
          <p className="text-2xl">Users</p>

          <div style={{ position: "relative", width: 300 }}>
            <input
              ref={dateInputRef}
              className="border px-4 py-2 rounded w-full"
              readOnly
              placeholder="Select date range"
            />
          </div>

          <div className="border w-80">
            <TextField
              placeholder="Search users."
              name="query"
              onChange={(e) => handleSearch(e)}
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="px-4 py-4 border-b text-left">Date</th>
                <th className="px-4 py-4 border-b text-left">User Name</th>

                <th className="px-4 py-4 border-b text-left">Email</th>
                <th className="px-4 py-4 border-b text-left">Phone</th>
                <th className="px-4 py-4 border-b text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={user?._id} className="hover:bg-gray-100">
                  <td className="px-4 py-4 border-b">
                    {DateFormatter(user?.createdAt)}
                  </td>
                  <td className="px-4 py-4 border-b">{user.name}</td>

                  <td className="px-4 py-4 border-b">{user?.email}</td>
                  <td className="px-4 py-4 border-b">{user?.phone}</td>
                  <td className="px-4 py-4 border-b">
                    <div className="flex gap-5">
                      <button
                        className="text-green-500 hover:text-green-700"
                        onClick={() =>
                          navigate(`/admin/user/details/${user?._id}`)
                        }
                      >
                        View details
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!filteredUsers?.length ? (
            <div className="w-full flex justify-center mt-3">
              <p>No data found.</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default UserTable;
